export default __webpack_public_path__ + "static/hodler_tablet@2x-c5438843158b039315b2c3b139abe3ed.png";